    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            states: null,
        }
    }
    
    const state = getDefaultState()

    const getters = {
        states: state => {
            return state.states
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        states: (state, payload) => {
            state.states = payload
        },
    }

    const actions = {
       
        getStates: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/states')
            .then(
                res => {
                    commit('updating', false)
                    commit('states', res.data)
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        }
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }